<template>
  <b-badge
    v-if="temporary"
    :variant="expired ? 'danger' : 'warning'"
    class="game-expiration-badge"
  >{{ label }}</b-badge>
</template>

<script>
export default {
  name: 'GameExpirationBadge',
  props: {
    temporary: {
      type: Boolean,
      default: false,
    },
    expired: {
      type: Boolean,
      default: false,
    },
    // Human-readable expiration date (e.g. "5/1/2025") or null.
    expirationDate: {
      type: String,
      default: null,
    },
  },
  computed: {
    label() {
      if (this.expired) return 'Expired';
      return this.expirationDate ? `Temporary — Expires ${this.expirationDate}` : 'Temporary';
    },
  },
};
</script>

<style lang="scss" scoped>
.game-expiration-badge {
  font-size: 1rem;
  padding: 0.3em 0.7em;
  line-height: 1.3;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/components/GameExpirationBadge.vue